module.exports = __webpack_public_path__ + "static/img/1.6a94db1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/youxiji/1.jpg
// module id = 3vKf
// module chunks = 1